import { render, staticRenderFns } from "./PasswordResetQuestion.vue?vue&type=template&id=165d7027&"
import script from "./PasswordResetQuestion.vue?vue&type=script&lang=js&"
export * from "./PasswordResetQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports